import React, { useMemo } from 'react';
import { COMMON_TIMEZONES, formatTimezoneLabel, detectBrowserTimezone } from '../lib/tz';

/**
 * Lightweight timezone selector — IANA zones, with offset labels.
 *
 * Props:
 *   value:        currently selected timezone (defaults to browser tz)
 *   onChange:     (tz) => void
 *   testId:       data-testid prefix
 *   includeAuto:  if true, prepend an "Auto-detect" option
 */
export default function TimezoneSelect({
  value, onChange, testId = 'tz-select', includeAuto = false, className = '',
}) {
  const now = useMemo(() => new Date(), []);
  const effective = value || detectBrowserTimezone();
  // Make sure the current value is always present in the list (covers
  // detected zones outside our short list).
  const options = useMemo(() => {
    const set = new Set(COMMON_TIMEZONES);
    set.add(effective);
    return Array.from(set).sort();
  }, [effective]);

  return (
    <select
      data-testid={testId}
      value={effective}
      onChange={(e) => onChange(e.target.value)}
      className={`h-9 rounded-sm border border-input bg-background px-3 text-sm ${className}`}
    >
      {includeAuto && <option value="__auto__">Auto-detect ({detectBrowserTimezone()})</option>}
      {options.map((tz) => (
        <option key={tz} value={tz}>{formatTimezoneLabel(tz, now)}</option>
      ))}
    </select>
  );
}
